import { useEffect, useState } from "react";
import $ from 'jquery'
import { toast } from 'react-toastify';
import { useLocation } from "react-router-dom";
import { auth, db, RecaptchaVerifier, signInWithPhoneNumber, collection, addDoc, doc, setDoc, getDoc } from '../../config/firebase'
import { v4 as uuidv4 } from 'uuid';
import { async } from "@firebase/util";

export default function Form() {
    const [name, SetName] = useState('');
    const [email, SetEmail] = useState('');
    const [company, setCompany] = useState('');
    const [phone, SetPhone] = useState();
    const [otp, SetOtp] = useState();
    const [contry, SetContry] = useState('+49');
    const [otpresult, SetOtpresult] = useState('')
    const [otpsent, setotpsent] = useState(false);
    const [err, SetErr] = useState(false);
    const [dis, SetDis] = useState(false);
    const [uuid, SetUuid] = useState(uuidv4());
    const location = useLocation()
    const params = new URLSearchParams(location.search);

    const delay = ms => new Promise(res => setTimeout(res, ms));


    const date = new Date();
    const showTime = date.getHours()
        + ':' + date.getMinutes()
        + ":" + date.getSeconds();
    const showDate = date.getDate() + '/' + date.getMonth() + '/' + date.getFullYear();


    const CancelPhoneVerification = (e) => {
        e.preventDefault()
        setotpsent(false);
        SetPhone('')
        SetDis(false)
        $('#recaptcha-container').html('');
        $('#SendOtpBtn').removeClass('cursorNotAllowed')
    }

    const generateRecaptcha = () => {
        window.applicationVerifier = new RecaptchaVerifier('recaptcha-container', {}, auth);
    }

    const SendOTp = async (e) => {
        if (name === '' || email === '' || company === '') {
            SetErr(true);
            return
        }
        e.preventDefault()
        let phoneNumber = contry + phone
        if (phoneNumber === "" || phoneNumber.length < 10) return;
        generateRecaptcha();
        const docSnap = await getDoc(doc(db, 'Users', phone));
        if (docSnap.exists()) {
            addData(uuid, false, true);
        } else {
            addUserList()
            addData(uuid, false, true);
        }
        let appVerifier = window.applicationVerifier;
        signInWithPhoneNumber(auth, phoneNumber, appVerifier)
            .then((confirmationResult) => {
                window.confirmationResult = confirmationResult;
                $('#SendOtpBtn').addClass('cursorNotAllowed')
                SetOtpresult(confirmationResult);
                $('#recaptcha-container').html('')
                setotpsent(true)
                SetDis(true)
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const ValidateOtp = (e) => {
        e.preventDefault()
        if (otp === null || otpresult === null)
            return;
        let confirmationResult = window.confirmationResult;
        confirmationResult.confirm(otp).then((result) => {
            addData(uuid, true, false);
        }).catch((error) => {
            alert(error);
            window.location.reload()
        });
    }

    const addUserList = async (uuid) => {
        const docRef = await setDoc(doc(db, "Users", contry + phone), {
            name: name,
            number: contry + phone,
            email: email,
            company: company,
            date: showDate,
            time: showTime,
            create_at: Date.now()
        });
    }

    const addData = async (uid, verified, isOtp) => {
        const docRef = await setDoc(doc(db, "Leads", uid), {
            id: uid,
            name: name,
            email: email,
            company: company,
            number: contry + phone,
            date: showDate,
            time: showTime,
            otp: verified,
            leadstatus: '',
            leadvalue:'',
            leadinterest:'',
            utm_source: params.get("utm_source"),
            utm_medium: params.get("utm_medium"),
            utm_campaign: params.get("utm_campaign"),
            utm_id: params.get("utm_id"),
            create_at: Date.now()
        }).then((docRef) => {
            if(isOtp){
                toast.success('OTP Sent to Your Mobile No');
            }else {
                toast.success('Thank you for your submission We will contact you shortly! For any queries, please reach out to contact support@6storage.com');
                reloadFunction();
               
            }
        }).catch((error) => {
            toast.error('Something Problem !!!');
        });
    }

    const reloadFunction = async () => {
        await delay(5555);
        window.location.reload();
      };

    return (
        <>
            <div className="main-container">
                <div className="container pb-4 pt-5">
                    <div className="row">
                        <div className="col-md-7 text-white h-100 px-4 p-lg-5 my-4" style={{ background: 'linear-gradient(to right, #3061ad 0%,#2696da 100%)' }}>
                            <div className="px-lg-4 py-3 my-2">
                                <h1 className="mb-3 text-break">Vergrößern Sie Ihr Selbstlagerungsgeschäft durch Automatisierung.</h1>
                                <h5 className="lh-base text-break">Mit der fortschrittlichen Selfstorage-Software 6Storage. Verwalten Sie Ihre Anlagen, Prozesse und Sicherheit in einem einzigen Softwarepaket.</h5>
                            </div>
                        </div>
                        <div className="col-md-5  p-3 p-lg-5 br-20 background-grey">
                            <div className="row">
                                <div className="col-12 my-3">
                                    <label className="formMandatory mb-2"> vollständiger Name </label>
                                    <input value={name} onChange={e => SetName(e.target.value)} className="form-control" type="text" disabled={dis} />
                                    {err && name === '' ?
                                        <div className="invalid-feedback d-block position-absolute">
                                            vollständiger Name
                                        </div> : <></>}
                                </div>
                                <div className="col-12 my-3">
                                    <label className="formMandatory mb-2">  Geschäftliche E-Mail </label>
                                    <input value={email} onChange={e => SetEmail(e.target.value)} className="form-control" type="email" disabled={dis} />
                                    {err && email === '' ?
                                        <div className="invalid-feedback d-block position-absolute">
                                            Geschäftliche E-Mail
                                        </div> : <></>}
                                </div>
                                <div className="col-12 my-3">
                                    <label className="formMandatory mb-2">  Unternehmen  </label>
                                    <input value={company} onChange={e => setCompany(e.target.value)} className="form-control" type="text" disabled={dis} />
                                    {err && company === '' ?
                                        <div className="invalid-feedback d-block position-absolute">
                                            Unternehmen
                                        </div> : <></>}
                                </div>
                                <div className="col-12 my-3 position-relative de-otp-btn">
                                    <label className="formMandatory mb-2">  Telefonnummer  </label>
                                    <div class="input-group mb-3">
                                        <select value={contry} onChange={e => SetContry(e.target.value)} className="input-group-text">
                                            <option value="+49" defaultChecked>+49</option>
                                            <option value="+43">+43</option>
                                        </select>
                                        <input
                                            type="number"
                                            onInput={(e) => {
                                                if (e.target.value.length > e.target.maxLength)
                                                    e.target.value = e.target.value.slice(0, e.target.maxLength);
                                            }}
                                            onChange={e => SetPhone(e.target.value)} class="form-control numberinput"
                                            value={phone}
                                            maxLength={10}
                                            disabled={dis}
                                        />
                                        {otpsent && <svg onClick={e => CancelPhoneVerification(e)} style={{ right: '120px', top: '10px' }} className="position-absolute" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20px" height="20px"><linearGradient id="wRKXFJsqHCxLE9yyOYHkza" x1="9.858" x2="38.142" y1="9.858" y2="38.142" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f44f5a" /><stop offset=".443" stop-color="#ee3d4a" /><stop offset="1" stop-color="#e52030" /></linearGradient><path fill="url(#wRKXFJsqHCxLE9yyOYHkza)" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" /><path d="M33.192,28.95L28.243,24l4.95-4.95c0.781-0.781,0.781-2.047,0-2.828l-1.414-1.414	c-0.781-0.781-2.047-0.781-2.828,0L24,19.757l-4.95-4.95c-0.781-0.781-2.047-0.781-2.828,0l-1.414,1.414	c-0.781,0.781-0.781,2.047,0,2.828l4.95,4.95l-4.95,4.95c-0.781,0.781-0.781,2.047,0,2.828l1.414,1.414	c0.781,0.781,2.047,0.781,2.828,0l4.95-4.95l4.95,4.95c0.781,0.781,2.047,0.781,2.828,0l1.414-1.414	C33.973,30.997,33.973,29.731,33.192,28.95z" opacity=".05" /><path d="M32.839,29.303L27.536,24l5.303-5.303c0.586-0.586,0.586-1.536,0-2.121l-1.414-1.414	c-0.586-0.586-1.536-0.586-2.121,0L24,20.464l-5.303-5.303c-0.586-0.586-1.536-0.586-2.121,0l-1.414,1.414	c-0.586,0.586-0.586,1.536,0,2.121L20.464,24l-5.303,5.303c-0.586,0.586-0.586,1.536,0,2.121l1.414,1.414	c0.586,0.586,1.536,0.586,2.121,0L24,27.536l5.303,5.303c0.586,0.586,1.536,0.586,2.121,0l1.414-1.414	C33.425,30.839,33.425,29.889,32.839,29.303z" opacity=".07" /><path fill="#fff" d="M31.071,15.515l1.414,1.414c0.391,0.391,0.391,1.024,0,1.414L18.343,32.485	c-0.391,0.391-1.024,0.391-1.414,0l-1.414-1.414c-0.391-0.391-0.391-1.024,0-1.414l14.142-14.142	C30.047,15.124,30.681,15.124,31.071,15.515z" /><path fill="#fff" d="M32.485,31.071l-1.414,1.414c-0.391,0.391-1.024,0.391-1.414,0L15.515,18.343	c-0.391-0.391-0.391-1.024,0-1.414l1.414-1.414c0.391-0.391,1.024-0.391,1.414,0l14.142,14.142	C32.876,30.047,32.876,30.681,32.485,31.071z" /></svg>}
                                        <button class="btn btn-success" id="SendOtpBtn" onClick={e => SendOTp(e)}>verifizieren</button>
                                    </div>
                                </div>
                                <div id="recaptcha-container"></div>
                                {otpsent &&
                                    <div className="col-12" >
                                        <div className="col-12 my-3">
                                            <label className="formMandatory mb-2">  OTP  </label>
                                            <input value={otp} onChange={e => SetOtp(e.target.value)} type="number" class="form-control numberinput"
                                                onInput={(e) => {
                                                    if (e.target.value.length > e.target.maxLength)
                                                        e.target.value = e.target.value.slice(0, e.target.maxLength);
                                                }}
                                                maxLength={6}
                                            />
                                        </div>
                                        <div className="col-12 mt-5 text-center" >
                                            <button onClick={e => ValidateOtp(e)} className="btn text-white px-4 br-20" style={{ background: '#FA1378' }}>Kostenlose Demo</button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}